window.jQuery = require('jquery');
window.$ = require('jquery');

require('bootstrap/js/src/util.js');
require('bootstrap/js/src/tooltip.js');
